<kt-portlet>


	<kt-portlet-header [sticky]="true" [title]="portletTitle" [class]="'kt-portlet__head--lg'">

	</kt-portlet-header>


	<kt-portlet-body>


		<p *ngIf="(dataSource.hasItems$ | async)">
			<ngb-alert [dismissible]="false" [type]="'light'">
			<strong>Aşağıda teslim edilen talepler onayınızı bekliyor.</strong>&nbsp; Gerekli kontrolleri yaptıktan sonra &nbsp;<strong> Kaydet </strong>&nbsp; düğmesine basarak onay işlemini tamamlayabilirsiniz!
			</ngb-alert>
		  </p>

		<!-- start::DATA GRID -->
		<div class="mat-table__wrapper">


			<mat-table class="lmat-elevation-z8" #table [dataSource]="dataSource">

				<ng-container matColumnDef="kod">
					<mat-header-cell *matHeaderCellDef>Ürün Kodu</mat-header-cell>
					<mat-cell class="duration-cell"
							  *matCellDef="let delivery">
						<span class="mobile-label">Ürün Kodu:</span>
						{{delivery.productCode}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="name">
					<mat-header-cell *matHeaderCellDef>Ürün Adı</mat-header-cell>
					<mat-cell class="duration-cell"
							  *matCellDef="let delivery">
						<span class="mobile-label">Ürün Adı:</span>
						{{delivery.productName}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="hedef">
					<mat-header-cell *matHeaderCellDef>Hedef Nokta</mat-header-cell>
					<mat-cell class="duration-cell"
							  *matCellDef="let delivery">
						<span class="mobile-label">Hedef Nokta:</span>
						{{delivery.targetAddressName}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="tarih">
					<mat-header-cell *matHeaderCellDef>Teslim Tarihi</mat-header-cell>
					<mat-cell class="duration-cell"
							  *matCellDef="let delivery">
						<span class="mobile-label">Teslim Tarihi:</span>
						{{delivery.shipmentDate | date:'dd.MM.yyyy'}}
					</mat-cell>
				</ng-container>


				<ng-container matColumnDef="teslimAdedi">
					<mat-header-cell *matHeaderCellDef>Teslim Adedi</mat-header-cell>
					<mat-cell *matCellDef="let delivery">
						<span class="mobile-label">Teslim Adedi:</span>
						{{delivery.productQuantity}}
					</mat-cell>
				</ng-container>


				<ng-container matColumnDef="teslimAlinanAdet">
					<mat-header-cell *matHeaderCellDef>Teslim Alınan Adet</mat-header-cell>
					<mat-cell *matCellDef="let delivery">
						<span class="mobile-label">Teslim Alınan Adet:</span>
						<input #adetValue type="number" id="{{delivery.rowGuid}}" name="teslimAlinanAdet{{delivery.rowGuid}}" value="{{delivery.productQuantity}}" min="0" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" />
					</mat-cell>
				</ng-container>



				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

				<mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClicked(row)"></mat-row>

			</mat-table>

			<!-- NO RECORD -->

			<div class="mat-table__message" *ngIf="!(dataSource.hasItems$ | async) && !(dataSource.loading$ | async)">
				Gösterilecek kayıt bulunamadı!
			</div>

			<!-- AFTER UPDATE-->

			<div class="mat-table__message" color="success" *ngIf="(isUpdated$ | async)">
				Kayıt işlemi tamamlandı.
			</div>


		</div>

		<div style="margin-top: 10px;">
		<button mat-raised-button color="primary" class="pull-right" *ngIf="!(isUpdated$ | async) && (dataSource.hasItems$ | async)" [disabled]="(loadinButton$ | async)" (click)="edit()" >
			<div class="spinner-container" *ngIf="(loadinButton$ | async)">
				<mat-spinner diameter="24"></mat-spinner>
			</div>Kaydet
		</button>
	</div>
		<!-- end::DATA GRID -->


	</kt-portlet-body>

</kt-portlet>
